<template>
    <div id="availability">
        <div class="material-icons time-icon">calendar_today</div>
        <div class="content">
            <div class="header" @click="changeVisible">
                <div class="header-titles">
                    <span class="header-title">{{ $t("calendar.calendars") }}</span>
                    <span class="header-sub-title">{{ $t("calendar.calendarsDesc") }}</span>
                </div>
                <div class="material-icons" v-if="visible">expand_less</div>
                <div class="material-icons" v-else>expand_more</div>
            </div>
            <div v-if="visible">
                <div class="calendar-list">
                    <a-select class="select-calendar" show-search v-model="calendarData.calendarId">
                        <a-select-option :value="calendar._id" v-for="(calendar, i) in calendars" :key="i">
                            {{ calendar.summary }}
                        </a-select-option>
                    </a-select>
                    <div v-for="calendar of availabilityCalendars" class="calendar-item">
                        <input
                            class="item-checkbox"
                            type="checkbox"
                            v-model="calendar.isSelected"
                            :disabled="isDisabled(calendar)"
                            @input="changeSelectedCalenderIds(calendar)"
                        />
                        <span>{{ calendar.summary }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import _ from "lodash";
import moment from "moment/moment";

const log = log2("Calendar");
export default {
    name: "Calendar",
    components: {},
    props: {
        value: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            visible: false,
            availabilityCalendars: [],
            calendars: [],
            calendarData: _.cloneDeep(this.value),
            availabilityCalendarIds: [],
            calendarId: "",
            calendarList: [],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            getCalendarList: "calendar/getCalendarList",
        }),
        ...mapMutations({}),
        changeSelectedCalenderIds(calendar) {
            this.calendarData.availabilityCalendarIds.find((id) => id === calendar._id)
                ? this.calendarData.availabilityCalendarIds.splice(
                      this.calendarData.availabilityCalendarIds.findIndex(
                          (id) => id.toString() === calendar._id.toString()
                      ),
                      1
                  )
                : this.calendarData.availabilityCalendarIds.push(calendar._id);
        },
        changeVisible() {
            this.visible = !this.visible;
        },
        isDisabled(calendar) {
            return this.calendarData.calendarId === calendar._id;
        },
    },
    async mounted() {
        this.calendarList = await this.getCalendarList({ userId: this.user._id, userName: this.user.name });

        this.calendars = this.calendarList.filter(
            (calendar) => calendar.userId._id === this.user._id && calendar.type === "supsis"
        );
        const defaultSelectedCalendar = this.calendarList.filter(
            (calendar) => calendar.userId._id === this.user._id && calendar.type === "supsis" && calendar.isDefault
        )[0]._id;
        this.calendarData.calendarId = this.calendarData.calendarId || defaultSelectedCalendar;

        console.log("this.calendarData.availabilityCalendarIds", this.calendarData.availabilityCalendarIds);
        this.availabilityCalendars = this.calendarList.map((calendar) => {
            console.log("calendar._id...", calendar._id);
            calendar.isSelected =
                this.calendarData.availabilityCalendarIds.includes(calendar._id) ||
                this.calendarData.calendarId === calendar._id;
            return calendar;
        });
    },
    beforeDestroy() {},
    watch: {
        calendarData: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
#availability {
    .ant-select-selection {
        border: none !important;
        border-radius: 0 !important;
        margin-top: 6px;
        background-color: white !important;
    }

    .ant-select-selection__rendered {
        margin-left: 0 !important;
    }
}
</style>

<style lang="scss" scoped>
#availability {
    display: flex;
    flex-direction: row;
    margin-top: 20px;

    .time-icon {
        margin-top: 7px;
        margin-right: 20px;
        font-size: 20px;
    }

    .content {
        display: flex;
        flex-direction: column;
        width: 100%;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            cursor: pointer;
            border-radius: 5px;
            padding: 5px;

            &:hover {
                background-color: #e5e5e5;
            }

            .header-titles {
                display: flex;
                flex-direction: column;

                .header-title {
                    color: black;
                    font-weight: 500;
                    font-size: 16px;
                }

                .header-sub-title {
                    font-size: 12px;
                }
            }
        }

        .calendar-list {
            margin-top: 3px;
            margin-left: 10px;

            .select-calendar {
                width: 100%;
                margin-bottom: 10px;
            }

            .calendar-item {
                display: flex;
                align-items: center;

                .item-checkbox {
                    margin-right: 10px;
                    height: 15px;
                }
            }
        }
    }
}
</style>
